export type SalesPlatform = 'tiktokshop' | 'amazon';

export interface BenchmarkProduct {
  id: string;
  name: string;
  brand: string;
  imgPath: string;
  price: string;
  revenue6m: string;
  sales6m: string;
  posts: string;
  reason: string;
  reasonEn?: string;
  notRecommendedReason?: string;
  notRecommendedReasonEn?: string;
}

export interface BenchmarkBrand {
  name: string;
  why: string;
  whyEn?: string;
  imgPath: string;
  products: BenchmarkProduct[];
}

export const TIKTOK_SHOP_BRANDS: BenchmarkBrand[] = [
  {
    name: 'OLLY',
    why: '대중 가격대 데일리 뷰티 구미 카테고리 인기 브랜드',
    whyEn: 'Popular mass-market daily beauty gummy brand',
    imgPath: '/campaign-planning/logo_olly.png',
    products: [
      {
        id: 'olly_beauty',
        name: 'OLLY Undeniable Beauty Gummy (Hair/Skin/Nails)',
        brand: 'OLLY',
        imgPath: '/campaign-planning/olly_beauty.webp',
        price: '$13.99',
        revenue6m: '$3,931',
        sales6m: '281',
        posts: '107',
        reason: '대중 가격($13.99) 데일리 뷰티 구미, 카테고리 인기 상품',
        reasonEn: 'Mass-market price ($13.99) daily beauty gummy — top product in category',
      },
      {
        id: 'olly_skin',
        name: 'OLLY Glowing Skin Collagen Gummy',
        brand: 'OLLY',
        imgPath: '/campaign-planning/olly_skin.webp',
        price: '$13.99',
        revenue6m: '$3,386',
        sales6m: '242',
        posts: '33',
        reason: '콜라겐+히알루론산 피부 타겟 — 우리 제품과 성분 인접',
        reasonEn: 'Collagen + hyaluronic acid skin-targeted — close ingredient overlap with our product',
        notRecommendedReason: 'Posts 수 50개 미만',
        notRecommendedReasonEn: 'Under 50 posts',
      },
      {
        id: 'olly_hair',
        name: 'OLLY Heavenly Hair Gummy (Keratin·Biotin)',
        brand: 'OLLY',
        imgPath: '/campaign-planning/olly_hair.webp',
        price: '$15.99',
        revenue6m: '$3,582',
        sales6m: '224',
        posts: '13',
        reason: '케라틴·비오틴 모발 타겟 라인',
        reasonEn: 'Keratin + biotin hair-targeted line',
        notRecommendedReason: 'Posts 수 50개 미만',
        notRecommendedReasonEn: 'Under 50 posts',
      },
    ],
  },
  {
    name: 'Weem',
    why: 'Hair/Skin/Nails 카테고리 상위 판매 브랜드',
    whyEn: 'Top-selling brand in the Hair/Skin/Nails category',
    imgPath: '/campaign-planning/logo_weem.png',
    products: [
      {
        id: 'weem',
        name: 'Weem Hair Skin & Nails Gummies',
        brand: 'Weem',
        imgPath: '/campaign-planning/weem.png',
        price: '$35',
        revenue6m: '$128,800',
        sales6m: '3,680',
        posts: '2,450',
        reason: '6개월 Rev $128,800·판매 3,680개로 Hair/Skin/Nails 카테고리 상위 판매',
        reasonEn: '6M Rev $128,800 · 3,680 units sold — top seller in Hair/Skin/Nails',
      },
    ],
  },
  {
    name: 'Vitamatic',
    why: '저가 비오틴 구미, 동일 카테고리 가성비 비교군',
    whyEn: 'Low-price biotin gummies — value benchmark in the same category',
    imgPath: '/campaign-planning/logo_vitamatic.png',
    products: [
      {
        id: 'vitamatic',
        name: 'Vitamatic Biotin 10,000mcg Beauty Gummies',
        brand: 'Vitamatic',
        imgPath: '/campaign-planning/vitamatic.png',
        price: '$11',
        revenue6m: '$9,779',
        sales6m: '889',
        posts: '273',
        reason: '저가 비오틴 hair/nail 비교군 (콜라겐 아님)',
        reasonEn: 'Low-price biotin hair/nail benchmark (not collagen)',
      },
    ],
  },
  {
    name: 'Micro Ingredients',
    why: '멀티 콜라겐 카테고리 최상위 판매, 직접 경쟁 제품',
    whyEn: 'Top-selling multi-collagen brand — closest direct competitor',
    imgPath: '/campaign-planning/logo_microingredients.png',
    products: [
      {
        id: 'micro_collagen',
        name: 'Micro Ingredients Multi Collagen Peptides Gummy',
        brand: 'Micro Ingredients',
        imgPath: '/campaign-planning/product_microingredients_multicollagenpeptides.png',
        price: '$27',
        revenue6m: '$128,250',
        sales6m: '4,750',
        posts: '2,501',
        reason: '멀티 콜라겐(피부·모발·손톱) — 우리 제품과 가장 유사한 직접 경쟁, Rev $128,250·판매 4,750',
        reasonEn: 'Multi-collagen (skin/hair/nails) — closest direct competitor, Rev $128,250 · 4,750 units',
      },
    ],
  },
  {
    name: 'K2O by Kylie Jenner',
    why: '셀럽 프리미엄 액상 콜라겐, 카테고리 매출 최상위',
    whyEn: 'Celebrity premium collagen — top-grossing in the category',
    imgPath: '/campaign-planning/logo_k2o.png',
    products: [
      {
        id: 'k2o',
        name: 'K2O by Kylie Jenner Advanced Skin Hydration Mix',
        brand: 'K2O by Kylie Jenner',
        imgPath: '/campaign-planning/product_k2o_skinhydrationmix.png',
        price: '$39.99',
        revenue6m: '$720,220',
        sales6m: '18,010',
        posts: '10,693',
        reason: '액상 콜라겐 + 셀럽(Kylie Jenner), Rev $720K·판매 18,010 카테고리 최상위',
        reasonEn: 'Celebrity (Kylie Jenner) collagen, Rev $720K · 18,010 units — top in category',
      },
    ],
  },
  {
    name: 'SugarbearPro',
    why: '프리미엄 비오틴 구미 포지셔닝 비교군',
    whyEn: 'Premium biotin gummy — price positioning benchmark',
    imgPath: '/campaign-planning/logo_sugarbearpro.png',
    products: [
      {
        id: 'sugarbearpro',
        name: 'SugarbearPro Hair Vitamin Gummy (Biotin 6000mcg)',
        brand: 'SugarbearPro',
        imgPath: '/campaign-planning/sugarbearpro.webp',
        price: '$43',
        revenue6m: '$30,143',
        sales6m: '701',
        posts: '174',
        reason: '프리미엄 비오틴 구미 (콜라겐 아님)',
        reasonEn: 'Premium biotin gummy (not collagen)',
      },
    ],
  },
  {
    name: "MaryRuth's",
    why: '프리미엄 Hair&Skin 번들, 가격 포지셔닝 비교군',
    whyEn: 'Premium Hair & Skin bundle — price positioning benchmark',
    imgPath: '/campaign-planning/logo_maryruths.png',
    products: [
      {
        id: 'maryruths',
        name: "MaryRuth's Hair & Skin Gummy Bundle",
        brand: "MaryRuth's",
        imgPath: '/campaign-planning/maryruths.webp',
        price: '$133',
        revenue6m: '$11,039',
        sales6m: '83',
        posts: '69',
        reason: '프리미엄 Hair&Skin 번들 가격 포지셔닝 (콜라겐 아님)',
        reasonEn: 'Premium Hair & Skin bundle price positioning (not collagen)',
      },
    ],
  },
];
